import { render, staticRenderFns } from "./AccountChangeRequest.vue?vue&type=template&id=9f071a60&"
import script from "./AccountChangeRequest.vue?vue&type=script&lang=js&"
export * from "./AccountChangeRequest.vue?vue&type=script&lang=js&"
import style0 from "./AccountChangeRequest.vue?vue&type=style&index=0&id=9f071a60&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports